export default __webpack_public_path__ + "static/media/phone_wayabank.97b5710e.png";